import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  paper: {
    margin: theme.spacing(3, 1, 3, 1),
    padding: theme.spacing(5, 1, 5, 1),
  },
}));

export default function ProductDetailDropshippedProductInfo() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12}>
          <Typography variant="h6" align="center">
            {t(
              'this_product_is_dropshipped_product_you_are_not_allow_to_modify'
            )}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
